import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 * 用户信息
 * 
*/

export const userInfo = () => Http.get(`${baseUrl}/info`)

/**
 * 修改用户信息
 * @param params
*/

export const editUserInfo = params => Http.put(`${baseUrl}/info`, params)

/**
 * 修改密码
 * @param params
*/

export const editPass = params => Http.put(`${baseUrl}/info/password`, params)